import { Globe } from "@phosphor-icons/react";
import { Panel } from "@/components/admin/AdminUI";
import MiniBars from "@/components/admin/MiniBars";

const sum = (days, f) => (days || []).reduce((n, d) => n + (d[f] || 0), 0);

function PathList({ items, muted }) {
  if (!items?.length) return <p className="cw-muted text-sm">No views yet.</p>;
  const max = Math.max(1, ...items.map((p) => p.views));
  return (
    <ul className="space-y-2 text-sm">
      {items.slice(0, 8).map((p) => (
        <li key={p.path} className="grid grid-cols-[120px_1fr_48px] items-center gap-3" data-testid={`site-path-${p.path}`}>
          <span className="truncate font-mono text-xs">{p.path}</span>
          <span className="h-2 rounded-full bg-[var(--cw-surface-tertiary)]"><span className={`block h-2 rounded-full ${muted ? "bg-[var(--cw-border-strong)]" : "bg-[var(--cw-brand)]"}`} style={{ width: `${(p.views / max) * 100}%` }} /></span>
          <span className="text-right tabular-nums">{p.views}</span>
        </li>
      ))}
    </ul>
  );
}

// Website tiles from GET /admin/dashboard `site` (and `test.site`, shown muted).
export default function SiteTiles({ s, muted = false, testId = "dashboard-site" }) {
  if (!s) return null;
  const c = s.waitlist_conversion || {};
  return (
    <div className={`grid gap-5 lg:grid-cols-[1fr_1.3fr_1fr] ${muted ? "opacity-80" : ""}`} data-testid={testId}>
      <Panel className={`p-6 ${muted ? "bg-[var(--cw-surface)]" : ""}`}>
        <div className="flex items-center gap-2"><Globe size={18} className={muted ? "cw-muted" : "cw-brand-text"} aria-hidden /><p className="cw-soft text-sm">Page views, 14 days</p></div>
        <p className="mt-3 text-3xl font-semibold tabular-nums" data-testid={`${testId}-views`}>{sum(s.daily, "views")}</p>
        <p className="cw-soft mt-1 text-sm">{sum(s.daily, "uniques")} unique visits</p>
        <div className="mt-4"><MiniBars days={s.daily} field="views" muted={muted} testId={`${testId}-chart`} /></div>
      </Panel>
      <Panel className={`p-6 ${muted ? "bg-[var(--cw-surface)]" : ""}`}><p className="cw-soft mb-4 text-sm">Views by page</p><PathList items={s.by_path} muted={muted} /></Panel>
      <Panel className={`p-6 ${muted ? "bg-[var(--cw-surface)]" : ""}`} data-testid={`${testId}-conversion`}>
        <p className="cw-soft text-sm">Waitlist conversion</p>
        <p className="mt-3 text-3xl font-semibold tabular-nums">{c.rate_pct ?? 0}%</p>
        <p className="cw-soft mt-1 text-sm">{c.waitlist_signups ?? 0} website signups / {c.home_views ?? 0} home views</p>
      </Panel>
    </div>
  );
}
